import { styled } from 'styled-components';

export const StyledLineGroup = styled.g`
    fill: none;
    stroke: blue;
`;
